<div class="flex flex-col h-full mt-4">
    <div class="flex-grow">
        <textarea class="w-full h-full border border-gray-300 rounded-base p-2 resize-none" size="large" pInputTextarea
            [(ngModel)]="promptText" placeholder="Write a prompt..."></textarea>
    </div>

    <div class="relative w-full my-4">
        <div class="overflow-x-auto no-scrollbar">
            <div class="flex gap-2 w-max mx-auto">
                <app-button
                    [icon]="(aiAssistant.loading && currentAction == ToolingAction.CONTINUE) ? 'pi pi-sparkles pi-spin' : 'pi pi-sparkles'"
                    iconPos="right" label="Continue" variant="filled" severity="primary"
                    (clicked)="onActionClick(ToolingAction.CONTINUE)"
                    [disabled]="aiAssistant.loading || promptText.length==0" />
                <app-button
                    [icon]="(aiAssistant.loading && currentAction == ToolingAction.SUMMARIZE) ? 'pi pi-sparkles pi-spin' : 'pi pi-sparkles'"
                    iconPos="right" label="Summarize" variant="filled" severity="primary"
                    (clicked)="onActionClick(ToolingAction.SUMMARIZE)"
                    [disabled]="aiAssistant.loading || promptText.length==0" />
                <app-button
                    [icon]="(aiAssistant.loading && currentAction == ToolingAction.TRANSLATE) ? 'pi pi-sparkles pi-spin' : 'pi pi-sparkles'"
                    iconPos="right" label="Translate" variant="filled" severity="primary"
                    (clicked)="onActionClick(ToolingAction.TRANSLATE)"
                    [disabled]="aiAssistant.loading || promptText.length==0" />
            </div>
        </div>
    </div>

    <div class="flex-grow">
        <div class="relative h-full">
            <textarea class="w-full h-full border border-gray-300 rounded-base p-2 resize-none" pInputTextarea
                [(ngModel)]="aiAssistant.response" disabled="true"></textarea>

            <app-button icon="pi pi-clipboard" class="absolute bottom-2 right-2" (clicked)="copyResponseToClipboard()"
                variant="outlined" [disabled]="!aiAssistant.response" label="Copy" severity="contrast" />
        </div>
    </div>
</div>